import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-switch-portal',
  templateUrl: './switch-portal.component.html',
  styleUrls: ['./switch-portal.component.scss']
})
export class SwitchPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
